import { PostBoInvestorProfileEndpoint } from '@Common/types/bo/b2b/investor_profile';

import { InvestorProfileGridSicavInstrumentAllocation } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/hooks/useB2bSicavGridLogic';

export const transformFormSicavGridToBoGrid = (
  grid: InvestorProfileGridSicavInstrumentAllocation[],
) => {
  const tmpGrid: PostBoInvestorProfileEndpoint['Client']['RequestBody']['allocations'] = [];
  grid.forEach((row) => {
    if (row.instrument_id === undefined) {
      return;
    }
    tmpGrid.push({
      min_years_to_retirement: row.year,
      allocation_instruments: [
        {
          allocation_percent: 100,
          instrument_id: row.instrument_id,
        },
      ],
    });
  });
  return tmpGrid;
};
